import { render } from "./TeamMemberManager.vue?vue&type=template&id=6d25914b"
import script from "./TeamMemberManager.vue?vue&type=script&lang=js"
export * from "./TeamMemberManager.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__